import Layout from "../../../layout/Layout";
import React, { useEffect, useState, useRef } from "react";
import { Container } from "@mui/system";
import {
  Button,
  Grid,
  TextField,
  Autocomplete,
  FormControl,
  Typography,
  Select,
  InputLabel,
  MenuItem,
  Alert as MuiAlert,
  Snackbar,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import {
  config,
  statusAPI,
  assetsAPI,
  userData,
  ticketAPI,
  ticket1API,
  usersAPI,
} from "../../../config";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import axios from "axios";
import { TextEditor, getInnerHtml, addContentTo } from "text-editor-react";
import { useNavigate } from "react-router-dom";

let intIssueSubType = 0;

export default function NewTicket() {
  let navigate = useNavigate();
  const [issueTypeList, setIssueTypeList] = useState([]);
  const [assetsList, setAssetsList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [prioritizationList, setPrioritizationList] = useState([]);
  const [categorisationList, setCategorisationList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [filteredUserList, setFilteredUserList] = useState([]);
  const [targetUserID, setTargetUserID] = useState(null);

  const [messageType, setMessageType] = React.useState("success");
  const [message, setMessage] = React.useState("");

  const [fileName, setfileName] = useState("");
  const [intType, setIntType] = useState("");
  const [intDepartment, setIntDepartment] = useState("");
  const [intCategorisation, setIntCategorisation] = useState("");
  const [intPrioritization, setIntPrioritization] = useState("");
  const [loading, setLoading] = useState(false);

  let assetsRef = useRef(false);

  useEffect(() => {
    if (assetsRef.current === false) {
      addContentTo("", "txtDescription");
      let data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "1",
      });
      getStatus(data, "issueTypeList");

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "35",
      });
      getStatus1(data, "departmentList");

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "33",
      });
      getStatus1(data, "prioritizationList");

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "34",
      });
      getStatus1(data, "categorisationList");

      getUsers();

      return () => {
        assetsRef.current = true;
      };
    }
  }, []);

  const options = issueTypeList.map((option) => {
    const firstLetter = option.category;
    return {
      firstLetter: firstLetter,
      ...option,
    };
  });

  // Fetch all users for the agent dropdown
  const getUsers = () => {
    const data = JSON.stringify({
      intUserID: 0,
    });
    config.method = "PATCH";
    config.data = data;
    config.url = usersAPI;
    axios(config)
      .then(function (response) {
        setUserList(response.data["data"]);
        setFilteredUserList(response.data["data"]);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const getStatus = (data, type) => {
    config.method = "PATCH";
    config.data = data;
    config.url = ticketAPI;
    axios(config)
      .then(function (response) {
        if (type === "issueTypeList") setIssueTypeList(response.data["data"]);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  // FETCH ASSETS DATA START
  const fetchAssets = () => {
    const data = JSON.stringify({
      intUserID: userData.id,
      txtAssets: "",
      intIssueSubType: intIssueSubType,
    });

    config.method = "PATCH";
    config.data = data;
    config.url = assetsAPI;
    axios(config)
      .then(function (response) {
        setAssetsList([]);
        if (response.data.data.length > 0) {
          setAssetsList(JSON.parse(response.data.data[0].assets));
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };
  // FETCH ASSETS DATA END

  // SUBMIT TICKET START
  const validationSchema = Yup.object().shape({
    intCategorisation: Yup.string().required("Categorisation is required"),
    intSubType: Yup.string().required("Category is required"),
    intDepartment: Yup.string().required("Department is required"),
    intPrioritization: Yup.string().required("Prioritization is required"),
    intType: Yup.string().required("Type is required"),
    intUserID: Yup.string().required("User is required"),
    txtSubject: Yup.string().required("Subject is required"),
    // txtDescription: Yup.string().required("Description is required"),
  });

  const formOptions = {
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  };

  const { handleSubmit, formState, register, setValue, reset } =
    useForm(formOptions);
  const { errors } = formState;

  const onSubmit = (requestData) => {
    console.log(requestData);
    setLoading(true);

    const formData = new FormData();
    if (files && files.length > 0) {
      files.forEach((file) => {
        formData.append("file[]", file);
      });
    }

    formData.append("intAssets", requestData.intAssets);
    formData.append("intCategorisation", requestData.intCategorisation);
    formData.append("intSubType", requestData.intSubType);
    formData.append("intDepartment", requestData.intDepartment);
    formData.append("intPrioritization", requestData.intPrioritization);
    formData.append("intType", requestData.intType);
    formData.append("txtSubject", requestData.txtSubject);
    formData.append("txtDescription", getInnerHtml("txtDescription"));
    // intUserID = the user this ticket is for (selected from dropdown, or the agent themselves)
    // intAdminSubmittedBy: flag — always 1 here since only agents/admins use this form
    formData.append("intUserID", targetUserID ? targetUserID : userData.id);
    formData.append("intAdminSubmittedBy", 1);

    var axiosConfig = {
      method: "post",
      url: ticket1API,
      mode: "cors",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + userData.token,
      },
      data: formData,
    };

    axios(axiosConfig)
      .then(function (response) {
        console.log(response);
        reset();
        setOpen(true);
        setMessageType("success");
        setMessage(response.data.message);
        setTimeout(function () {
          navigate(`/agent/list`);
        }, 2000);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setMessageType("warning");
        setMessage(error.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  // SUBMIT TICKET END

  const getStatus1 = (data, type) => {
    config.method = "patch";
    config.url = statusAPI;
    config.data = data;

    axios(config)
      .then(function (response) {
        if (type === "issueTypeList") setIssueTypeList(response.data["data"]);
        else if (type === "categorisationList")
          setCategorisationList(response.data["data"]);
        else if (type === "departmentList")
          setDepartmentList(response.data["data"]);
        else if (type === "prioritizationList")
          setPrioritizationList(response.data["data"]);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const [files, setFiles] = useState([]);

  function handleChange(event) {
    if (event.target.files.length > 0) {
      setFiles((prev) => [...prev, ...Array.from(event.target.files)]);
    }
  }

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const [open, setOpen] = React.useState(false);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <Layout>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={loading}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Please wait...
        </Typography>
      </Backdrop>
      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={messageType}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Grid container spacing={5}>
        <Grid item lg={12} md={12} xs={12}>
          <div className={`white-bg`}>
            <Container>
              <form
                onSubmit={handleSubmit(onSubmit)}
                encType="multipart/form-data"
              >
                <Autocomplete
                  id="department-autocomplete"
                  options={departmentList}
                  getOptionLabel={(option) => option.name || ""}
                  value={departmentList.find(d => d.id === intDepartment) || null}
                  onChange={(event, newValue) => {
                    const selectedDept = newValue ? newValue.id : "";
                    setIntDepartment(selectedDept);
                    setValue("intDepartment", selectedDept);

                    // Filter users by selected department
                    if (selectedDept) {
                      const filtered = userList.filter(user => user.department == selectedDept);
                      setFilteredUserList(filtered);
                    } else {
                      setFilteredUserList(userList);
                    }

                    // Clear previously selected user since department changed
                    setTargetUserID(null);
                    setValue("intUserID", "");
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Department" variant="outlined" error={!!errors.intDepartment} />
                  )}
                  className="form-control"
                  fullWidth
                />

                {/* User Selection Dropdown - agents can raise tickets on behalf of any user */}
                <FormControl className={`form-control`} fullWidth>
                  <Autocomplete
                    id="user-selection"
                    key={intDepartment} // Force re-render/clear when department changes
                    options={filteredUserList}
                    getOptionLabel={(option) =>
                      (option.emp_no || "") + " - " + (option.username || option.name || "")
                    }
                    fullWidth
                    renderInput={(params) => (
                      <TextField {...params} label="User" variant="outlined" />
                    )}
                    onChange={(event, newValue) => {
                      setTargetUserID(newValue ? newValue.id : null);
                      setValue("intUserID", newValue ? newValue.id : "");
                    }}
                    value={filteredUserList.find(u => u.id === targetUserID) || null}
                    className={` ${errors.intUserID ? "is-invalid" : ""}`}
                  />
                  <Typography className="invalid-feedback">
                    {errors.intUserID?.message}
                  </Typography>
                </FormControl>

                <FormControl className={`form-control`} fullWidth>
                  <Autocomplete
                    id="grouped-demo"
                    options={options}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.name}
                    fullWidth
                    renderInput={(params) => (
                      <TextField {...params} label="Category" />
                    )}
                    onChange={(event, newValue) => {
                      if (newValue !== null) {
                        intIssueSubType = newValue.id;
                        setValue("intSubType", newValue.id);
                        fetchAssets();
                      }
                    }}
                    className={` ${errors.intSubType ? "is-invalid" : ""}`}
                  />
                  <Typography className="invalid-feedback">
                    {errors.intSubType?.message}
                  </Typography>
                </FormControl>

                <Autocomplete
                  id="type-autocomplete"
                  options={["New", "Error", "Replacement"]}
                  getOptionLabel={(option) => option}
                  value={intType || null}
                  onChange={(event, newValue) => {
                    setIntType(newValue || "");
                    setValue("intType", newValue || "");
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Type" variant="outlined" error={!!errors.intType} />
                  )}
                  className="form-control"
                  fullWidth
                />

                <FormControl className={`form-control`} fullWidth>
                  <Autocomplete
                    id="assets-select"
                    options={assetsList}
                    fullWidth
                    renderInput={(params) => (
                      <TextField {...params} label="Assets" />
                    )}
                    onChange={(event, newValue) => {
                      setValue("intAssets", newValue !== null ? newValue : "");
                    }}
                    className={` ${errors.intAssets ? "is-invalid" : ""}`}
                  />
                  <Typography className="invalid-feedback">
                    {errors.intAssets?.message}
                  </Typography>
                </FormControl>

                <Autocomplete
                  id="prioritization-autocomplete"
                  options={prioritizationList}
                  getOptionLabel={(option) => option.name || ""}
                  value={prioritizationList.find(p => p.id === intPrioritization) || null}
                  onChange={(event, newValue) => {
                    const val = newValue ? newValue.id : "";
                    setIntPrioritization(val);
                    setValue("intPrioritization", val);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Prioritization" variant="outlined" error={!!errors.intPrioritization} />
                  )}
                  className="form-control"
                  fullWidth
                />

                <Autocomplete
                  id="categorisation-autocomplete"
                  options={categorisationList}
                  getOptionLabel={(option) => option.name || ""}
                  value={categorisationList.find(c => c.id === intCategorisation) || null}
                  onChange={(event, newValue) => {
                    const val = newValue ? newValue.id : "";
                    setIntCategorisation(val);
                    setValue("intCategorisation", val);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Categorisation" variant="outlined" error={!!errors.intCategorisation} />
                  )}
                  className="form-control"
                  fullWidth
                />

                <FormControl className={`form-control`} fullWidth>
                  <TextField
                    id="outlined-multiline-static"
                    label="Subject"
                    fullWidth
                    {...register("txtSubject")}
                  />
                  <Typography className="invalid-feedback">
                    {errors.txtSubject?.message}
                  </Typography>
                </FormControl>

                <FormControl className={`form-control`} fullWidth>
                  {/* <TextField
                    id="outlined-multiline-static"
                    label="Description"
                    multiline
                    rows={4}
                    fullWidth
                    {...register("txtDescription")}
                  /> */}
                  <TextEditor
                    id="txtDescription"
                    fullWidth
                    showHeadings={false}
                    showUndoRedo={false}
                    showJustify={false}
                  />
                  <Typography className="invalid-feedback">
                    {errors.txtDescription?.message}
                  </Typography>
                </FormControl>

                <FormControl className={`form-control`} fullWidth>
                  <input
                    type="file"
                    multiple
                    onChange={handleChange}
                    style={{ marginBottom: "10px" }}
                  />
                  {files.length > 0 && (
                    <div style={{ marginTop: "10px" }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Selected Files:
                      </Typography>
                      <ul style={{ listStyle: "none", padding: 0 }}>
                        {files.map((f, index) => (
                          <li
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginBottom: "5px",
                              padding: "5px 10px",
                              backgroundColor: "#f5f5f5",
                              borderRadius: "4px",
                            }}
                          >
                            <Typography variant="caption">{f.name}</Typography>
                            <Button
                              size="small"
                              color="error"
                              onClick={() => handleRemoveFile(index)}
                              style={{ minWidth: "auto", padding: "2px 5px" }}
                            >
                              Remove
                            </Button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <Typography className="invalid-feedback">
                    {errors.intfile?.message}
                  </Typography>
                </FormControl>

                <div className="empty-space-20"></div>
                <Button type="submit" className={`btn-primary`} disabled={loading}>
                  {loading ? "Creating..." : "Create"}
                </Button>
              </form>
            </Container>
          </div>
        </Grid>
      </Grid>
    </Layout>
  );
}